import {ProjectBaseDto} from 'lib/dtos/Project';

export function getAddress(project: ProjectBaseDto): string {
    const {zip, street, location} = project;
    return `${street}, ${zip} ${location}`;
}
